import { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import api from '../api';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!token) {
      setError('Missing or invalid reset link. Please request a new one.');
      return;
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: password });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.response?.data?.detail || 'Could not reset your password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page" data-testid="reset-password-page">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1 className="auth-title">Choose a new password</h1>
            <p className="auth-subtitle">
              Pick something you'll remember. Minimum 6 characters.
            </p>
          </div>

          {success ? (
            <div
              data-testid="reset-password-success"
              style={{
                background: '#dcfce7',
                border: '1px solid #86efac',
                color: '#166534',
                padding: 16,
                borderRadius: 8,
              }}
            >
              <p style={{ margin: 0, fontWeight: 600 }}>Password updated.</p>
              <p style={{ marginTop: 6, fontSize: '0.9rem' }}>
                Redirecting you to the sign-in page…
              </p>
            </div>
          ) : (
            <>
              {error && (
                <div className="alert alert-error" data-testid="reset-password-error">
                  {error}
                </div>
              )}
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="form-label">New Password</label>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="form-input"
                    placeholder="Enter new password"
                    required
                    data-testid="reset-password-new-input"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Confirm Password</label>
                  <input
                    type="password"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    className="form-input"
                    placeholder="Re-enter new password"
                    required
                    data-testid="reset-password-confirm-input"
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-primary btn-lg"
                  style={{ width: '100%' }}
                  disabled={loading}
                  data-testid="reset-password-submit-btn"
                >
                  {loading ? 'Updating…' : 'Update password'}
                </button>
              </form>
            </>
          )}

          <div className="auth-footer" style={{ marginTop: 20 }}>
            <Link to="/login" data-testid="reset-back-login">Back to sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
